import React from 'react';
import { FacetProps } from '../Facets';
import KeywordFacet from '../keyword/KeywordFacet';

/**
 * Custom visualization for the type facet values.
 */
export default function TypeFacet(props: FacetProps) {
  return <KeywordFacet {...props} labelResolver={getTypeLabel} />
}

function getTypeLabel(key: string) {
  // Leaves only the last part of the IRI
  // E.g. "https://swapi.co/vocabulary/Character" becomes just "Character"
  return key.slice(key.lastIndexOf('/') + 1);
}
